import { render } from "./PoweredBy.vue?vue&type=template&id=18303b04&scoped=true"
import script from "./PoweredBy.vue?vue&type=script&lang=js"
export * from "./PoweredBy.vue?vue&type=script&lang=js"

import "./PoweredBy.vue?vue&type=style&index=0&id=18303b04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18303b04"]])

export default __exports__